import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  sectionTitle: {
    color: "#118CC6",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 800,
    textTransform: "uppercase",
  },
  descriptionText: {
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
  },
  switchLabel: {
    fontSize: "17px",
    lineHeight: "26px",
    fontWeight: 400,
    marginRight: "22px",
  },
  editButton: {
    padding: "0.5rem 1.1rem",
  },
  structureNameTitle: {
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 700,
    color: "#9A9A9A",
  },
  structureNameText: {
    fontSize: "17px",
    lineHeight: "26px",
    fontWeight: 400,
    marginRight: "22px",
  },
  avatar: {
    width: 100,
    height: 100,
    boxShadow: "0px 0px 8px 8px #B5B5B517",
    objectFit: "cover",
  },
  defaultAvatar: {
    width: 100,
    height: 100,
    backgroundColor: "#BDBDBD",
    boxShadow: "0px 0px 8px 8px #B5B5B517",
    "& img": {
      objectFit: "cover",
      width: 42,
      height: 42,
    },
  },
  deleteButton: {
    color: "red",
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: 400,
    alignItems: "flex-start",
    width: "auto",
    alignSelf: "flex-start",
  },
};
